import React, {Component} from 'react';
import axios from 'axios';
import {FaCloud} from "react-icons/fa";
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import {Alert, Card, CardBody} from 'reactstrap';
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";

class AdminConsoleVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            error: false,
            messageError: '',
            btnSubmit: true,
            vpsConsole: {},
            vps: {},
            isNotification: false,
            textNotification: '',
            isConsole: 0,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailVps(this.props.vpsId);
    }

    getDetailVps = (vpsId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };

        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/getConsoleVps/' + vpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if (ref.data.error === 0) {
                    this.setState({
                        vpsConsole: {
                            vm_host: ref.data.vm_host,
                            vm_ticket: ref.data.vm_ticket,
                        },
                        loadPage: false,
                        isLoading: false,
                        isConsole: 1
                    })
                }
                else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                            isConsole: 0
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                    isConsole: 0
                })
            })
    }

    redirectBack = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectBack();
    }

    loadConsole = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="fillter_log mt-4 mb-4">
                        <div id="buttonBar">
                            <div className="buttonC">
                                <button id="cad" className="btn btn-primary">
                                    Send Ctrl+Alt+Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <Card className="card" id="card-console">
                        <CardBody className="card-body table-responsive p-0">
                            <input type="hidden" id="vm_host" value={ this.state.vpsConsole.vm_host } />
                            <input type="hidden" id="vm_ticket" value={ this.state.vpsConsole.vm_ticket } />
                            <div id="wmksContainer" />
                        </CardBody>
                    </Card>
                </div>
                <input type="hidden" id="page" value="console"/>
                <input type="hidden" id="console" value={ this.state.isConsole }/>
                <input type="hidden" id="checkConsole" value="0"/>
            </div>
        )
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Console VPS"} page={"VPS"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            { this.state.messageError }
                                        </div>
                                    </Alert>
                                ) : (
                                    this.loadConsole()
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminConsoleVps' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminConsoleVpsComponent);